import React, { Fragment, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

export function Appearer({ children, appeared = false, order = 0, template = 'lg' }) {
  const [shown, setShown] = useState(appeared);

  useEffect(() => {
    let time = null;
    if (!shown) {
      time = setTimeout(() => {
        setShown(true);
      }, order * 30);
    }
    return () => {
      clearTimeout(time);
    };
  }, [shown, order]);

  return (
    <CssProductAppearer shown={shown ? true : undefined} className={`_fv ${template}`}>
      {children}
    </CssProductAppearer>
  );
}

const CssProductAppearer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  transition: transform 150ms ease-out, opacity 350ms ease-out;
  ${({ shown }) => !shown && css`
    opacity: 0;
    transform: translateY(10px) scale(1);
  `};
`;
